import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { Picture } from "../../../../../components/wpl/image/src";

export const StatisticsHero = () => {
    return (
        <section css={sectionStyles}>
            <StatisticsLeft />
            <StatisticsMobile />
            <div css={imgOverride}>
                <Picture
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/w55h774xe1t6o3j53b505y2xbx10xlmk.webp",
                        alt: ""
                    }}
                />
            </div>
        </section>
    );
};

const imgOverride = css({
    marginInlineStart: 29,
    marginInlineEnd: 23,

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: "100%",
        height: "auto"
    }
});

const sectionStyles = css({
    display: "grid",
    position: "relative",
    gridTemplateColumns: "1fr",
    gap: "32px",
    marginBlockStart: "75px",

    [media.above.sm]: {
        maxWidth: "min(1168px, calc(100% - 120px))",
        marginInline: "auto",
        marginBlockStart: "75px",
        gridTemplateColumns: "1fr 1fr"
    },

    [media.above.md]: {
        justifyContent: "start",
        gridTemplateColumns: "2fr 1fr"
    }
});

const mobileSwitch = css({
    marginBlockStart: 50,
    marginInlineStart: 24,
    marginInlineEnd: 24,
    width: "calc(100% - 60px)",
    [media.above.md]: {
        display: "none"
    }
});

const desktopSwitch = css({
    width: "100%",
    [media.below.md]: {
        display: "none"
    }
});

export const StatisticsLeft = () => (
    <svg
        viewBox="120 120 700 250"
        fill="none"
        css={desktopSwitch}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M167.848 213.951L152.688 250.521H140.415L160.564 206.137L167.848 213.951Z"
            fill="#BF63F3"
        />
        <path
            d="M167.849 204.316H135V213.951H167.849V204.316Z"
            fill="#FCA700"
        />
        <path
            d="M157.019 213.95H167.848L160.564 206.144L157.019 213.95Z"
            fill="#AE2A19"
        />
        <path
            d="M203.979 233.979C203.916 232.179 203.644 230.576 203.189 229.148H192.396C193.612 230.526 194.179 232.341 194.214 234.24C194.214 234.303 194.214 234.359 194.214 234.422C194.214 236.427 193.654 238.255 192.459 239.627H203.371C203.776 238.094 204 236.448 204 234.704C204 234.458 203.979 234.226 203.972 233.979H203.979Z"
            fill="#1868DB"
        />
        <path
            d="M190.376 219.154C181.086 217.396 172.194 221.595 169.133 229.141C168.455 230.815 168.056 232.65 168.007 234.626C168.007 236.392 168.224 238.065 168.636 239.62H179.73C178.583 238.29 178.045 236.532 178.01 234.626C178.01 234.556 178.003 234.486 178.003 234.415C178.003 232.453 178.563 230.561 179.807 229.141C181.107 227.657 183.155 226.679 186.119 226.679C189.083 226.679 191.096 227.657 192.403 229.141H203.196C201.267 223.121 196.122 220.237 190.383 219.154H190.376Z"
            fill="#1868DB"
        />
        <path
            d="M192.466 239.627C192.144 239.993 191.781 240.33 191.361 240.626C190.082 241.54 188.348 242.088 186.104 242.088C183.86 242.088 182.204 241.568 180.946 240.71V250.795C182.511 251.125 184.21 251.301 186.034 251.301C187.95 251.301 189.725 251.097 191.361 250.732C197.687 249.304 201.875 245.267 203.377 239.627H192.466Z"
            fill="#FCA700"
        />
        <path
            d="M180.952 240.703C180.491 240.387 180.078 240.028 179.736 239.62C178.59 238.291 178.051 236.533 178.016 234.627C178.016 234.557 178.009 234.486 178.009 234.416C178.009 234.05 178.037 233.692 178.072 233.333C178.086 233.227 178.1 233.122 178.121 233.009C178.156 232.749 178.205 232.496 178.268 232.25C178.296 232.13 178.324 232.011 178.359 231.891C178.408 231.729 178.464 231.568 178.52 231.406C178.569 231.272 178.611 231.146 178.666 231.019C178.771 230.773 178.883 230.52 179.016 230.288C179.24 229.88 195.919 204.316 195.919 204.316H183.196C183.196 204.316 170.495 226.56 170.25 226.961C169.831 227.65 169.46 228.382 169.146 229.141C168.468 230.815 168.069 232.651 168.02 234.627C168.02 236.392 168.237 238.066 168.649 239.62C170.173 245.303 174.416 249.41 180.966 250.788C182.532 251.119 184.231 251.294 186.055 251.294C187.971 251.294 189.746 251.091 191.382 250.725V240.619C190.103 241.533 188.369 242.082 186.125 242.082C183.881 242.082 182.225 241.561 180.966 240.703H180.952Z"
            fill="#82B536"
        />
        <path
            d="M203.979 233.979C203.916 232.179 203.644 230.576 203.189 229.148H192.396C193.612 230.526 194.179 232.341 194.214 234.24C194.214 234.303 194.214 234.359 194.214 234.422C194.214 236.427 193.654 238.255 192.459 239.627H203.371C203.776 238.094 204 236.448 204 234.704C204 234.458 203.979 234.226 203.972 233.979H203.979Z"
            fill="#09326C"
        />
        <path
            d="M178.995 230.287C179.03 230.231 179.072 230.175 179.107 230.111C179.051 230.203 179.009 230.266 178.995 230.287Z"
            fill="#09326C"
        />
        <path
            d="M169.712 227.889C169.789 227.749 169.866 227.608 169.95 227.467C169.873 227.608 169.789 227.749 169.712 227.889Z"
            fill="#1868DB"
        />
        <path
            d="M169.125 229.148C169.3 228.719 169.495 228.304 169.712 227.896C169.502 228.304 169.3 228.719 169.125 229.148Z"
            fill="#1868DB"
        />
        <path
            d="M178.003 234.423C178.003 234.057 178.031 233.698 178.066 233.347C178.024 233.705 178.003 234.064 178.003 234.423Z"
            fill="#09326C"
        />
        <path
            d="M179.108 230.118C179.178 230.013 179.275 229.851 179.408 229.654C179.303 229.802 179.206 229.964 179.108 230.118Z"
            fill="#09326C"
        />
        <path
            d="M178.255 232.25C178.283 232.13 178.311 232.011 178.346 231.891C178.394 231.729 178.45 231.568 178.506 231.406C178.555 231.272 178.597 231.146 178.653 231.019C178.758 230.773 178.87 230.527 178.996 230.288C178.485 231.202 178.185 232.243 178.066 233.319C178.08 233.213 178.094 233.115 178.108 233.009C178.143 232.749 178.192 232.496 178.255 232.25Z"
            fill="#09326C"
        />
        <path
            d="M178.01 234.634C178.01 234.563 178.003 234.493 178.003 234.423C178.003 234.057 178.031 233.698 178.066 233.347C178.066 233.347 178.066 233.34 178.066 233.333C178.185 232.257 178.485 231.216 178.996 230.302C179.003 230.287 179.045 230.217 179.108 230.126C179.206 229.964 179.296 229.809 179.408 229.662C180.45 228.044 183.372 223.55 186.475 218.782C179.387 218.683 173.019 221.989 169.95 227.474C169.873 227.615 169.79 227.756 169.713 227.896C169.503 228.304 169.3 228.719 169.125 229.148C168.447 230.822 168.049 232.658 168 234.634C168 236.399 168.217 238.073 168.629 239.627H179.723C178.576 238.298 178.038 236.54 178.003 234.634H178.01Z"
            fill="#09326C"
        />
        <path
            d="M186.111 242.088C183.903 242.088 182.211 241.568 180.953 240.71V250.795C182.518 251.125 184.217 251.301 186.042 251.301C187.957 251.301 189.733 251.097 191.368 250.731V240.625C190.089 241.54 188.355 242.088 186.111 242.088Z"
            fill="#164B35"
        />
        <text
            fill="#172B4D"
            fontFamily="Charlie Display"
            fontSize="40"
            fontWeight="bold"
            letterSpacing="0px"
        >
            <tspan x="285" y="256.5">
                of Jira Software customers
            </tspan>
            <tspan x="135" y="304.5">
                said they shipped projects faster after
            </tspan>
            <tspan x="135" y="352.5">
                adding Confluence
            </tspan>
        </text>
        <path
            d="M239.742 238.687C239.742 231.773 243.971 226.201 251.406 226.201C258.841 226.201 263.002 231.773 263.002 238.687C263.002 245.602 258.773 251.375 251.406 251.375C244.04 251.375 239.742 245.669 239.742 238.687ZM246.768 238.687C246.768 242.312 248.746 244.595 251.406 244.595C254.067 244.595 255.976 242.312 255.976 238.687C255.976 235.062 253.998 232.914 251.406 232.914C248.814 232.914 246.768 235.13 246.768 238.687Z"
            fill="#82B536"
        />
        <path
            d="M251.812 206.533H259.997L221.185 250.638H213L251.812 206.533Z"
            fill="#FCA700"
        />
        <path
            d="M210 218.348C210 211.366 214.297 205.861 221.732 205.861C229.167 205.861 233.328 211.366 233.328 218.348C233.328 225.329 229.099 230.968 221.732 230.968C214.366 230.968 210 225.262 210 218.348ZM217.094 218.348C217.094 221.973 219.072 224.188 221.732 224.188C224.393 224.188 226.302 221.973 226.302 218.348C226.302 214.723 224.256 212.507 221.732 212.507C219.072 212.507 217.094 214.723 217.094 218.348Z"
            fill="#1868DB"
        />
        <path
            d="M1052.97 462.373L1115.9 455.044L1165.89 323.87L1062.61 271.535L974.149 346.202L1052.97 462.373Z"
            fill="#FCA700"
        />
        <path
            d="M1095.15 171.012C1092.33 227.85 1119.97 249.916 1163.26 250.542C1203.87 251.13 1231.47 229.865 1232.3 172.998L1233.24 108.017L1096.09 106.031L1095.15 171.012Z"
            fill="#BF63F3"
        />
        <g opacity="0.5">
            <path
                d="M1201.74 379.067C1201.74 336.728 1228.37 318.69 1281.61 318.69L1306.67 318.69L1306.67 201.88L1271.44 201.88C1162.58 201.88 1102.26 241.871 1102.26 328.115C1102.26 386.144 1130.45 427.67 1180.6 451.189L1261.73 451.189C1221.3 443.45 1201.74 414.962 1201.74 379.067Z"
                fill="#1868DB"
            />
        </g>
        <path
            d="M1001.65 115.555C1002.07 114.139 992.496 96.1461 991.373 102.497C990.667 104.745 991.356 106.394 993.47 106.324C989.915 108.118 996.077 110.102 995.425 112.244C992.618 112.49 999.753 115.914 996.714 115.806C1000.62 137.381 1039.43 170.574 1007.73 124.909C1008.2 130.335 1005.62 125.923 1005.46 123.469C1009.84 125.608 1003.87 117.106 1002.15 115.741C1003.17 118.649 999.142 114.63 1001.64 115.567L1001.65 115.555Z"
            fill="#101214"
        />
        <path
            d="M982.189 163.27C981.15 160.632 959.156 155.347 956.951 154.5C951.9 153.571 953.571 159.876 957.557 159.687C958.346 159.988 964.126 160.038 962.302 162.023C965.164 166.918 974.714 164.607 976.736 168.867C977.732 167.755 979.706 168.852 980.409 168.224C980.697 169.594 982.708 169.752 982.764 169.383C989.189 173.535 992.334 164.754 984.754 163.873C984.963 163.552 983.3 162.393 982.207 163.264L982.189 163.27Z"
            fill="#101214"
        />
        <path
            d="M970.036 243.062C973.862 244.486 970.597 245.368 968.737 244.653C970.759 241.59 964.392 243.671 962.996 244.932C963.701 244.85 964.178 245.963 962.738 246.215C963.118 243.049 944.956 246.442 954.737 250.687C955.042 250.608 954.699 248.252 955.21 248.896C955.331 252.552 957.658 249.468 958.401 249.023C958.761 250.857 959.17 248.989 959.528 249.702C959.058 252.379 962.818 247.242 962.213 249.925C967.118 252.755 974.277 246.01 978.138 248.719C979.469 244.124 993.964 247.36 987.239 240.624C981.17 240.102 976.294 240.13 970.036 243.062Z"
            fill="#101214"
        />
        <path
            d="M927.018 208.589C926.755 214.554 938.919 210.588 942.772 212.159C947.539 214.565 993.794 216.346 980.096 207.742C966.093 207.321 954.686 204.528 937.642 206.164C934.855 206.228 925.843 204.718 927.018 208.589Z"
            fill="#101214"
        />
        <path
            d="M1048.98 129.304C1054.26 131.515 1049.51 137.43 1053.94 139.663C1062.17 142.674 1055.8 100.345 1048.64 103.346C1042.83 106.758 1051.07 125.719 1048.98 129.304Z"
            fill="#101214"
        />
        <path
            d="M1042.48 327.45C1041.85 327.203 1040.75 326.799 1039.06 326.457L1039.79 326.131C1032.63 325.605 1024.83 324.585 1018.22 326.662C1017.96 326.786 1017.52 327.003 1017.68 327.142C1017.99 328.051 1015.67 328.184 1014.7 328.506C1008.13 325.668 990.168 339.099 983.364 342.671C983.447 342.543 983.969 341.78 984.031 341.674C981.131 341.608 964.135 360.947 966.979 356.176C965.215 357.724 963.418 359.463 961.629 361.364C956.182 356.88 948.705 354.23 942.351 353.306L942.629 353.508C914.071 352.585 873.603 380.391 878.996 411.415C883.48 397.97 887.985 382.714 902.125 373.21C901.833 373.079 901.963 372.66 902.322 372.578L902.461 372.937C907.644 368.019 912.191 366.743 917.973 362.9C917.966 362.907 917.458 363.628 917.451 363.649C929.7 358.154 946.673 356.495 958.237 365.236C911.955 422.986 1007.13 415.269 964.695 364.108C981.764 341.919 1017.64 325.919 1042.49 327.464L1042.48 327.45ZM961.345 367.937C967.268 374.467 973.241 384.694 969.936 393.628L970.034 393.556L970.056 393.62C972.366 390.34 971.966 385.083 970.829 381.582C976.087 389.293 970.496 399.908 961.826 401.741L961.771 401.267C964.261 400.666 966.583 399.062 967.931 396.996C943.673 412.091 950.368 381.344 959.893 370.281C959.357 370.343 957.768 374.173 956.25 374.452C957.715 372.038 959.243 369.659 960.858 367.462L961.345 367.937Z"
            fill="#101214"
        />
        <path
            d="M1202.03 378.592C1202.03 336.252 1228.65 318.214 1281.9 318.214L1306.95 318.214L1306.95 201.405L1271.73 201.405C1162.86 201.405 1102.55 241.395 1102.55 327.64C1102.55 385.668 1130.74 427.195 1180.88 450.713L1262.01 450.713C1221.58 442.974 1202.03 414.487 1202.03 378.592Z"
            fill="#1868DB"
        />
    </svg>
);

export const StatisticsMobile = () => (
    <svg
        viewBox="0 0 327 203"
        fill="none"
        css={mobileSwitch}
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            fill="#101214"
            fontFamily="Charlie Display"
            fontSize="32"
            fontWeight="bold"
            letterSpacing="0px"
        >
            <tspan x="120" y="42.6">
                of Jira
            </tspan>
            <tspan x="0" y="80.6">
                Software customers
            </tspan>
            <tspan x="0" y="118.6">
                said they shipped
            </tspan>
            <tspan x="0" y="156.6">
                projects faster after
            </tspan>
            <tspan x="0" y="194.6">
                adding Confluence
            </tspan>
        </text>
        <path
            d="M26.8761 12.6413L14.4718 42.5623H4.43018L20.9161 6.24854L26.8761 12.6413Z"
            fill="#BF63F3"
        />
        <path d="M26.876 4.7583H0V12.6413H26.876V4.7583Z" fill="#FCA700" />
        <path
            d="M18.0159 12.6414H26.8761L20.9161 6.25439L18.0159 12.6414Z"
            fill="#AE2A19"
        />
        <path
            d="M55.9831 29.0287C55.9324 27.5557 55.7128 26.2438 55.3468 25.0757H46.6523C47.6322 26.2035 48.0883 27.688 48.1164 29.2416C48.1164 29.2934 48.1164 29.3394 48.1164 29.3912C48.1164 31.0311 47.6659 32.5272 46.703 33.6492H55.4932C55.8198 32.3948 55.9999 31.0484 55.9999 29.6214C55.9999 29.42 55.9831 29.2301 55.9774 29.0287H55.9831Z"
            fill="#1868DB"
        />
        <path
            d="M45.0251 16.8991C37.5414 15.4606 30.3787 18.8958 27.9122 25.0699C27.366 26.4394 27.045 27.9411 27.0056 29.558C27.0056 31.0023 27.1802 32.3717 27.5124 33.6434H36.449C35.5255 32.5559 35.0919 31.1174 35.0637 29.558C35.0637 29.5005 35.0581 29.443 35.0581 29.3854C35.0581 27.78 35.5086 26.2322 36.5109 25.0699C37.5583 23.8558 39.2082 23.056 41.5958 23.056C43.9834 23.056 45.6051 23.8558 46.6581 25.0699H55.3525C53.7984 20.1444 49.6539 17.7853 45.0308 16.8991H45.0251Z"
            fill="#1868DB"
        />
        <path
            d="M46.7083 33.6492C46.4492 33.9484 46.1564 34.2246 45.8186 34.4662C44.7881 35.2143 43.3916 35.6631 41.584 35.6631C39.7764 35.6631 38.4418 35.2373 37.4282 34.5353V42.7866C38.6896 43.057 40.0579 43.2009 41.5277 43.2009C43.0706 43.2009 44.5009 43.034 45.8186 42.7348C50.9147 41.5667 54.2877 38.2639 55.4984 33.6492H46.7083Z"
            fill="#FCA700"
        />
        <path
            d="M37.4339 34.5297C37.0622 34.2708 36.73 33.9773 36.4541 33.6436C35.5306 32.5561 35.097 31.1176 35.0688 29.5582C35.0688 29.5007 35.0632 29.4432 35.0632 29.3856C35.0632 29.0864 35.0857 28.7929 35.1139 28.4995C35.1251 28.4132 35.1364 28.3269 35.1533 28.2348C35.1815 28.0219 35.2209 27.8148 35.2715 27.6134C35.2941 27.5155 35.3166 27.4177 35.3448 27.3199C35.3842 27.1876 35.4292 27.0552 35.4743 26.9229C35.5137 26.8135 35.5475 26.71 35.5925 26.6064C35.677 26.405 35.7671 26.1979 35.8741 26.008C36.0543 25.6743 49.4901 4.7583 49.4901 4.7583H39.2415C39.2415 4.7583 29.0098 22.9583 28.8127 23.2863C28.4748 23.8502 28.1764 24.4487 27.923 25.0701C27.3768 26.4395 27.0558 27.9413 27.0164 29.5582C27.0164 31.0025 27.1909 32.3719 27.5232 33.6436C28.7507 38.2929 32.1688 41.6532 37.4452 42.781C38.7065 43.0514 40.0749 43.1953 41.5446 43.1953C43.0875 43.1953 44.5178 43.0284 45.8355 42.7292V34.4606C44.805 35.2087 43.4085 35.6575 41.6009 35.6575C39.7933 35.6575 38.4588 35.2317 37.4452 34.5297H37.4339Z"
            fill="#82B536"
        />
        <path
            d="M55.9831 29.0287C55.9324 27.5557 55.7128 26.2438 55.3468 25.0757H46.6523C47.6322 26.2035 48.0883 27.688 48.1164 29.2416C48.1164 29.2934 48.1164 29.3394 48.1164 29.3912C48.1164 31.0311 47.6659 32.5272 46.703 33.6492H55.4932C55.8198 32.3948 55.9999 31.0484 55.9999 29.6214C55.9999 29.42 55.9831 29.2301 55.9774 29.0287H55.9831Z"
            fill="#09326C"
        />
        <path
            d="M35.8569 26.0079C35.8851 25.9618 35.9189 25.9158 35.947 25.864C35.902 25.9388 35.8682 25.9906 35.8569 26.0079Z"
            fill="#09326C"
        />
        <path
            d="M28.3792 24.0457C28.4411 23.9306 28.503 23.8155 28.5706 23.7004C28.5087 23.8155 28.4411 23.9306 28.3792 24.0457Z"
            fill="#1868DB"
        />
        <path
            d="M27.906 25.0757C28.0468 24.7247 28.2045 24.3852 28.379 24.0515C28.2101 24.3852 28.0468 24.7247 27.906 25.0757Z"
            fill="#1868DB"
        />
        <path
            d="M35.0581 29.3913C35.0581 29.0921 35.0806 28.7987 35.1088 28.511C35.075 28.8044 35.0581 29.0979 35.0581 29.3913Z"
            fill="#09326C"
        />
        <path
            d="M35.9478 25.8697C36.0041 25.7834 36.0829 25.6511 36.1899 25.49C36.1054 25.6108 36.0266 25.7432 35.9478 25.8697Z"
            fill="#09326C"
        />
        <path
            d="M35.2607 27.6134C35.2832 27.5156 35.3057 27.4178 35.3339 27.32C35.3733 27.1876 35.4183 27.0553 35.4634 26.9229C35.5028 26.8136 35.5366 26.71 35.5817 26.6065C35.6661 26.4051 35.7562 26.2037 35.8576 26.0081C35.4465 26.7561 35.2044 27.6077 35.1086 28.488C35.1199 28.4017 35.1312 28.3212 35.1424 28.2349C35.1706 28.022 35.21 27.8148 35.2607 27.6134Z"
            fill="#09326C"
        />
        <path
            d="M35.0637 29.5639C35.0637 29.5064 35.0581 29.4488 35.0581 29.3913C35.0581 29.092 35.0806 28.7986 35.1088 28.5109C35.1088 28.5109 35.1088 28.5051 35.1088 28.4994C35.2045 27.619 35.4466 26.7674 35.8577 26.0194C35.8633 26.0079 35.8971 25.9504 35.9478 25.8755C36.0267 25.7432 36.0999 25.6166 36.19 25.4958C37.029 24.1724 39.3828 20.4955 41.883 16.5943C36.1731 16.5137 31.0431 19.2181 28.5711 23.7063C28.5091 23.8214 28.4416 23.9364 28.3796 24.0515C28.2107 24.3853 28.0474 24.7247 27.9066 25.0757C27.3604 26.4452 27.0394 27.947 27 29.5639C27 31.0082 27.1746 32.3776 27.5068 33.6493H36.4434C35.5199 32.5617 35.0863 31.1233 35.0581 29.5639H35.0637Z"
            fill="#09326C"
        />
        <path
            d="M41.5898 35.6632C39.8104 35.6632 38.4477 35.2373 37.4341 34.5354V42.7867C38.6954 43.0571 40.0638 43.2009 41.5335 43.2009C43.0765 43.2009 44.5068 43.0341 45.8244 42.7349V34.4663C44.7939 35.2143 43.3974 35.6632 41.5898 35.6632Z"
            fill="#164B35"
        />
        <path
            d="M81.6953 32.2279C81.6953 26.3012 85.2063 21.5254 91.3787 21.5254C97.5512 21.5254 101.005 26.3012 101.005 32.2279C101.005 38.1546 97.4946 43.103 91.3787 43.103C85.2629 43.103 81.6953 38.2121 81.6953 32.2279ZM87.528 32.2279C87.528 35.3351 89.1702 37.2914 91.3787 37.2914C93.5872 37.2914 95.1728 35.3351 95.1728 32.2279C95.1728 29.1207 93.5306 27.2794 91.3787 27.2794C89.2269 27.2794 87.528 29.1783 87.528 32.2279Z"
            fill="#82B536"
        />
        <path
            d="M91.7135 4.66797H98.5089L66.2876 42.472H59.4922L91.7135 4.66797Z"
            fill="#FCA700"
        />
        <path
            d="M57 14.7943C57 8.81013 60.5676 4.0918 66.74 4.0918C72.9125 4.0918 76.3668 8.81013 76.3668 14.7943C76.3668 20.7785 72.8559 25.6119 66.74 25.6119C60.6242 25.6119 57 20.721 57 14.7943ZM62.8893 14.7943C62.8893 17.9015 64.5315 19.8004 66.74 19.8004C68.9485 19.8004 70.5341 17.9015 70.5341 14.7943C70.5341 11.6872 68.8353 9.78831 66.74 9.78831C64.5315 9.78831 62.8893 11.6872 62.8893 14.7943Z"
            fill="#1868DB"
        />
    </svg>
);
